import React from 'react'
import { Link, graphql } from 'gatsby'

//import Bio from '../components/Bio'
import Layout from '../components/Layout'
import SEO from '../components/seo'
//import { rhythm } from '../utils/typography'

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMdx.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Blog posts on building a gatsby website"
          keywords={[`blog`, `gatsby`, `building`, `landing` ,`page` ]}
        />
        {/* <Bio /> */}
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug
          return (
            <div className="m-auto max-w-2xl"> 
            <div key={node.fields.slug}>
              <h3 className="tufan-bold-text-home text-xl text-tufan-red mb-2"
                // style={{
                //   marginBottom: rhythm(1 / 4),
                // }}
              >
                <Link className="text-tufan-red shadow-none no-underline" 
                // style={{ boxShadow: `none` }} 
                to={node.fields.slug}>
                  {title}
                </Link>
              </h3>
              <small className="tufan-text-content text-sm font-medium">{node.frontmatter.date}</small>
              <p className="tufan-text-content mb-10 mt-2 leading-normal" dangerouslySetInnerHTML={{ __html: node.excerpt }} />
            </div>
            </div>
          )
        })}
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMdx(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
          }
        }
      }
    }
  }
`
